import { Ok, Result } from 'ts-res';
import { DeviceType, KameleoonData } from 'src/kameleoonData/types';
import { KameleoonError } from 'src/kameleoonError';
import { EvaluationDataType } from 'src/targeting/types';
import { ConditionDataType, ICondition } from './types';

export class Device implements ICondition {
  private device?: DeviceType | null;

  constructor({ device }: ConditionDataType) {
    this.device = device;
  }

  public evaluate({
    targetingData,
  }: EvaluationDataType): Result<boolean, KameleoonError> {
    const deviceData = targetingData?.[KameleoonData.Device];

    if (deviceData) {
      const { device } = deviceData;

      return Ok(device === this.device);
    }

    return Ok(false);
  }
}
